import { render, staticRenderFns } from "./ResourceDashboard.vue?vue&type=template&id=05c8b738&scoped=true"
import script from "./ResourceDashboard.vue?vue&type=script&lang=js"
export * from "./ResourceDashboard.vue?vue&type=script&lang=js"
import style0 from "./ResourceDashboard.vue?vue&type=style&index=0&id=05c8b738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8b738",
  null
  
)

export default component.exports